import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpBaseService } from "@evento-ng/libs";
import { verifyEmailApi } from "src/app/services/constants/api.constants";

@Component({
  selector: "app-verify-email",
  templateUrl: "./verify-email.component.html",
  styleUrls: ["./verify-email.component.scss"],
})
export class VerifyEmailComponent implements OnInit {
  verified!: boolean;
  isRequestFinished!: boolean;
  errorMsg!: string;
  constructor(
    private route: ActivatedRoute,
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.verifyEmail();
  }

  verifyEmail() {
    this.spinner.show();
    const id = this.route.snapshot.paramMap.get("id");
    return this.dataService
      .post(`${verifyEmailApi}/${id}/validate`, {})
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.isRequestFinished = true;
          this.verified = true;
        },
        (error) => {
          this.errorMsg = error.error.message;
          this.isRequestFinished = true;
        }
      );
  }
}
